module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration004.687237f7.webp";